module.exports = __webpack_public_path__ + "img/e.f6415ea3.svg";